module.exports = __webpack_public_path__ + "static/media/print-slash.a98543cf.svg";